import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3391">
      <Navbar data-id="element-3392" />
      <main data-id="element-3393">
        <ConsularAffairs data-id="element-3394" />
      </main>
      <Footer data-id="element-3395" />
      <FeedbackPopup data-id="element-3396" />
    </div>;
}